
/** @format */

import { type Ref } from 'react'

const cx = (...classes: (string | boolean | undefined | null)[]) => classes.filter(Boolean).join(' ')

export const Container = ({ className, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx('w-full h-screen flex flex-col items-center justify-center', className)}
    {...props}
  >
    {children}
  </div>
)
Container.displayName = 'Container'

export const Title = ({ className, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <h1 ref={ref} className={cx('text-2xl font-semibold', className)} {...props}>
    {children}
  </h1>
)
Title.displayName = 'Title'

export const Image = ({ className, ref, ...props }: any & { ref?: Ref<any> }) => (
  <img ref={ref} className={cx('w-[500px]', className)} {...props} />
)
Image.displayName = 'Image'

export const Description = ({ className, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <p ref={ref} className={cx('text-base font-normal', className)} {...props}>
    {children}
  </p>
)
Description.displayName = 'Description'
